(() => {
  const MAIN_ACCORDION_SELECTOR = '[data-mobile-main-accordion]';
  const MAIN_SUMMARY_SELECTOR = '.drawer-menu__mobile-accordion-summary';
  const NESTED_ACCORDION_SELECTOR = '.drawer-menu__mobile-nested-accordion';
  const NESTED_SUMMARY_SELECTOR = '.drawer-menu__mobile-nested-summary';

  document.addEventListener('click', (event) => {
    const mainSummary = event.target.closest(MAIN_SUMMARY_SELECTOR);

    if (mainSummary) {
      const currentAccordion = mainSummary.closest(MAIN_ACCORDION_SELECTOR);
      const menuPage = mainSummary.closest(".drawer-menu__page[data-page-id='Menu']");
      if (!currentAccordion || !menuPage) return;

      menuPage.querySelectorAll(`${MAIN_ACCORDION_SELECTOR}[open]`).forEach((accordion) => {
        if (accordion !== currentAccordion) accordion.removeAttribute('open');
      });

      return;
    }

    const nestedSummary = event.target.closest(NESTED_SUMMARY_SELECTOR);
    if (!nestedSummary) return;

    const currentNestedAccordion = nestedSummary.closest(NESTED_ACCORDION_SELECTOR);
    const parentContent = nestedSummary.closest('.drawer-menu__mobile-accordion-content');
    if (!currentNestedAccordion || !parentContent) return;

    parentContent.querySelectorAll(`${NESTED_ACCORDION_SELECTOR}[open]`).forEach((accordion) => {
      if (accordion !== currentNestedAccordion) accordion.removeAttribute('open');
    });
  });
})();
